<template>
  <div class="page login-protocol-qb">
    <navigation> 用户授权协议</navigation> 
    <section class="content">
      <p class="text tab-2">
        《用户授权协议》（以下简称“<strong>本协议</strong>”）是重庆市崇天小额贷款有限公司（以下简称“<strong>天美贷</strong>”）与用户（以下简称“<strong>您</strong>”）所订立的有效合约。<strong>请您在同意本协议前，仔细阅读本协议各条款（特别是加粗字体条款），关注您在本协议中的权利与义务。您通过天美贷平台页面点击确认或以其他方式选择接受本协议，视为您已知悉并理解本协议各项条款，确认本次授权基于您的合法意思表示且由您本人所为。如您不同意本协议内容，或无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。如您对于本协议有任何疑问，请及时通过天美贷平台客服或客服电话4000100008与我们联系。</strong>
      </p>
      <p class="text tab-2">您即将通过本登录页面使用天美贷平台账户授权登录第三方站点或软件。</p>
      <p class="text tab-2">
        为了在天美贷平台向您展示多样化贷款产品或服务信息，天美贷与第三方合作机构合作，在天美贷平台嵌入第三方贷款产品或服务的页面，以供您及时查看和浏览。<strong>您同意授权天美贷将您提供的手机号码共享给第三方合作机构，以便第三方合作机构能够及时识别您的身份并为您提供第三方贷款产品或服务。</strong>天美贷会要求第三方合作机构依法使用您的上述信息，并应对您的信息保密。如您不希望天美贷向第三方合作机构提供上述信息，请勿点击“登录”、“确认”或进行后续操作。
      </p>
      <p class="text tab-2">
        请您知悉，第三方贷款产品或服务由相应第三方合作机构提供并由该等第三方合作机构就以上服务及数据安全独立承担全部责任。因该第三方贷款产品或服务或第三方合作机构使用您的信息产生的纠纷，或第三方贷款产品或服务违反相关法律法规，或您在使用第三方贷款产品或服务过程中遭受的损失，请您和第三方合作机构协商解决。请您认真充分了解相关贷款产品或服务的性质及风险并在此基础上作出自主决定，并根据自身情况谨慎、合理选择。
      </p>
      <p class="text tab-2">
        请您知悉，天美贷与第三方合作机构将依照法律法规及行业内通常标准的要求，采取相应的安全技术和管理措施，如数据去标识化、加密通道传输等，预防任何数据遭到泄露、篡改、丢失或者未经授权的访问等安全事件的发生。</p>
      <p class="text tab-2">
        <strong>请您知悉，尽管天美贷将采取相应的数据安全保护措施，但是在您使用网络服务的过程中仍可能存在不同的安全风险，例如网络欺诈往往会模仿、仿冒本登录页面的样式制作视觉感相似的页面，引诱用户输入账号和密码等。天美贷提醒您防范网络风险，不要向非天美贷的站点或任何人士透露您的天美贷账号、密码等相关信息。</strong>
      </p>
      <p class="text tab-2">您知悉同意，天美贷有权不时修改本协议，并将协议变更情况在天美贷平台上公示，该等变更自公告载明的生效时间起生效，并成为本协议的一部分。</p>
      <p class="text tab-2">本协议未尽事宜，参照《天美贷平台用户注册协议》及《天美贷个人信息保护政策》执行；《天美贷平台用户注册协议》或《天美贷个人信息保护政策》与本协议有冲突的，以本协议为准。</p>
      <p class="text tab-2">为免疑义，本协议中所称的第三方合作机构包括但不仅限于如下机构：</p>
      <table>
        <tr>
          <td>
            <p class="text tab-2">舟山闪盈网络科技有限公司 【普咚花】</p>
          </td>
          <td>
            <p class="text tab-2">0571-28851787</p>
          </td>
        </tr>
        <tr>
          <td>
            <p class="text tab-2">融易推网络技术（北京）有限公司【借钱】</p>
          </td>
          <td>
            <p class="text tab-2">010-82461045</p>
          </td>
        </tr>
      </table>
    </section>
  </div>

</template>

<script>
export default {
  name: 'river-diversion-protocol',

  description: '用户授权协议'
}
</script>
<style lang="less">
@import "../../../assets/less/mixin.less";

    .login-protocol-qb {
        background-color: #FAFAFA;
        padding-bottom: 45px;
        .content {
            padding: 0 48px;
            .title {
                font-weight: bolder;
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
                margin-top: 10px;
            }
            .text {
                color: #333333;
                font-size: 28px;
                text-indent: 40px;
                line-height: 44px;
            }
            .text:last-child {
                margin-bottom: 10px;
            }
            .underline {
                text-indent: 40px;
                font-weight: bold;
                text-decoration: underline;
            }
            .underline:last-child {
                margin-bottom: 10px;
            }
        }
        table {
    width: 100%;
    margin-top: 20px;
    border-collapse: collapse;
    border: 2px solid #000;
}
td {
    border: 2px solid #000;
}
    }
</style>